// WARNING! This is for jest testing with nock
// Do not rely on this for anything in production.
export var globalRequestTracking = { outboudRequestsCount: 0 };
